import ClearIcon from "@mui/icons-material/Clear";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { Box } from "@mui/system";
import PreviousStudiesModal from "./modals/previous-studies-modal";
import { useState } from "react";

const ReportActions = ({
  save,
  close,
  status,
  isDone,
  studies,
  updateBillingReport,
  cancelNeeded,
  previousStudiesNeeded,
  IS_REF_DOC,
}) => {
  const [viewPreviousStudies, setViewPreviousStudies] = useState(false);

  const handleOpenPreviousStudiesModal = () => setViewPreviousStudies(true);
  const handleClosePreviousStudiesModal = () => setViewPreviousStudies(false);

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        {previousStudiesNeeded && (
          <Button
            onClick={handleOpenPreviousStudiesModal}
            variant="outlined"
            color="secondary"
            size="large"
            startIcon={<ListAltIcon />}
            sx={{ fontSize: "14px" }}
          >
            View Previous Studies
          </Button>
        )}

        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          {cancelNeeded && (
            <Button
              onClick={close}
              variant="outlined"
              color="primary"
              size="large"
              startIcon={<ClearIcon />}
            >
              {IS_REF_DOC ? "Close" : "Cancel"}
            </Button>
          )}

          {status === "DICTATE" && !IS_REF_DOC && (
            <>
             <Button
              onClick={() => save("DICTATE")}
              variant="contained"
              color="secondary"
              size="large"
              startIcon={<SaveIcon />}
            >
              Save
            </Button>

            <Button
              onClick={() => save("TYPIST")}
              variant="contained"
              color="primary"
              size="large"
              startIcon={<SaveIcon />}
            >
              Complete
            </Button>
            </>
          )}
          {/* here */}
          {status === "TYPIST" && !IS_REF_DOC && (
            <>
            <Button
              onClick={() => save("TYPIST")}
              variant="contained"
              color="secondary"
              size="large"
              startIcon={<SaveIcon />}
            >
              Save
            </Button>

            <Button
              onClick={() => save("AUTHORIZE")}
              variant="contained"
              color="primary"
              size="large"
              startIcon={<SaveIcon />}
            >
              Complete
            </Button>
            </>
          )}

          {status === "AUTHORIZE" && !IS_REF_DOC && (
            <>
              <Button
                onClick={() => save("TYPIST")}
                variant="contained"
                color="primary"
                size="large"
                startIcon={<CancelIcon />}
              >
                Reject
              </Button>

              <Button
                onClick={() => save("DONE")}
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<CheckCircleIcon />}
              >
                Approve
              </Button>
            </>
          )}

          {isDone && !IS_REF_DOC && (
            <>
              <Button
                onClick={() => save()}
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<CheckCircleIcon />}
              >
                Finish
              </Button>
            </>
          )}

          {isDone && !IS_REF_DOC && (
            <>
              <Button
                onClick={() => updateBillingReport()}
                variant="contained"
                color="secondary"
                size="large"
                sx={{width:{xs:'80%',sm:'100%'}}}
                startIcon={<CheckCircleIcon />}
              >
                Resend billing
              </Button>
            </>
          )}
        </Box>
      </Stack>

      {viewPreviousStudies && (
        <PreviousStudiesModal
          studies={studies}
          close={handleClosePreviousStudiesModal}
        />
      )}
    </>
  );
};

export default ReportActions;
